import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BraintreeDropIn from 'braintree-dropin-react';
import braintree from 'braintree-web-drop-in';
import { connect } from 'react-redux';
import { CancelToken } from 'axios';
import { getClientToken, getCustomerId, updatePaymentMethod } from 'modules/subscriptions';

class PaymentForm extends Component {
  static propTypes = {
    customerId: PropTypes.string,
    updatePaymentMethod: PropTypes.func.isRequired,
  };

  constructor(...args) {
    super(...args);

    this.cancelToken = CancelToken.source();

    this.state = {
      clientToken: null,
      error: null,
      showWidget: !!this.props.customerId,
      displayButton: false,
    };
  }

  componentDidMount() {
    const { customerId } = this.props;

    this.requestToken(customerId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customerId !== this.props.customerId) {
      this.setState(
        { showWidget: !!nextProps.customerId, clientToken: null },
        () => {
          this.cancelToken.cancel();
          this.cancelToken = CancelToken.source();
          this.requestToken(nextProps.customerId);
        }
      );
    }
  }

  requestToken = customerId => {
    getClientToken(customerId, this.cancelToken)
      .then(clientToken => {
        this.setState(
          { clientToken, error: null },
        );
      })
      .catch(error => {
        this.setState({ error: error.message })
      })
  };

  handlePaymentMethod = payload => {
    this.props.updatePaymentMethod(this.props.account, payload.nonce);
  };

  onCreate = (instance) => {
    if(instance.isPaymentMethodRequestable()) {
      this.setState({ displayButton: false });
    }
    instance.on('noPaymentMethodRequestable', () => {
      this.setState({ displayButton: false });
    });
    instance.on('paymentMethodRequestable', ({ paymentMethodIsSelected }) => {
      this.setState({ displayButton: !paymentMethodIsSelected });
    });
  };

  onError = (error) => {
    this.setState({ error: error.message })
  };

  enableWidget = () => {
    this.setState({ showWidget: true });
  };

  renderSubmitButton = ({onClick, isDisabled, text}) => {
    if (!this.state.displayButton) {
      return null;
    }
    return (<button
      type="button"
      className="btn btn-primary mt-3"
      disabled={isDisabled}
      onClick={onClick}>
      { text }
      </button>);
  };

  render() {
    const { clientToken, error, showWidget } = this.state;

    if (!showWidget && !error) {
      return <button type="button" className="btn btn-primary mt-3" onClick={this.enableWidget}>
        Add payment method
      </button>
    }

    return (<div>
      { !!error && <div className="alert alert-danger">{ error }</div> }
      { !!clientToken && showWidget && <BraintreeDropIn
        authorizationToken={clientToken}
        braintree={braintree}
        handlePaymentMethod={this.handlePaymentMethod}
        onCreate={this.onCreate}
        onError={this.onError}
        renderSubmitButton={this.renderSubmitButton}
        submitButtonText="Update payment method"
      /> }
    </div>)
  }
}

const mapStateToProps = state => ({ customerId: getCustomerId(state) });
export default connect(mapStateToProps, { updatePaymentMethod })(PaymentForm)



// WEBPACK FOOTER //
// ./src/components/account/payment-form.js